import { useQuery } from "@apollo/client";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";

import { QUERY_CASES } from "api/queries/cases";
import GenericError from "components/GenericError";
import PageContainer from "components/Page/Container";
import PageContent from "components/Page/Content";
import Pagination, { getPaginationOffset } from "components/Pagination";
import { Case } from "ts/interfaces/common/case";
import Loading from "../../components/Loading";
import CaseList from "./components/CaseList";
import FilterCase from "./components/FilterCase";

interface Option {
  value: string;
  title: string;
}

interface QueryCasesData {
  cases: {
    cases: {
      totalCount: number;
      results: Case[];
    };
  };
  options_status: {
    options: Option[];
  };
}

const ITEMS_PER_PAGE = 20;

const Cases: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [currentPage, setCurrentPage] = useState(1);

  // Get filter parameters from URL
  const searchParam = searchParams.get("search") || "";
  const statusParam = searchParams.get("status") || "";
  const brokerParam = searchParams.get("broker") || "";

  const { loading, error, data, refetch } = useQuery<QueryCasesData>(
    QUERY_CASES,
    {
      fetchPolicy: "no-cache",
      variables: {
        search: searchParam,
        status: statusParam,
        broker: brokerParam,
        offset: getPaginationOffset(currentPage, ITEMS_PER_PAGE),
      },
    },
  );

  const cases = data?.cases?.cases;

  const renderContent = () => {
    if (!cases || loading) {
      return (
        <PageContainer>
          <div className="text-center">
            <Loading />
            <p className="mt-4">Loading Cases...</p>
          </div>
        </PageContainer>
      );
    }
    if (error) {
      return <GenericError error={error} />;
    }
    return (
      <>
        <CaseList cases={cases?.results} />
        <Pagination
          data={cases}
          itemsPerPage={ITEMS_PER_PAGE}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      </>
    );
  };

  return (
    <PageContent title="Cases">
      <div className="grid md:grid-cols-4 md:gap-8">
        <FilterCase refetch={refetch} options={data?.options_status.options} />
        <div className="md:col-span-3">{renderContent()}</div>
      </div>
    </PageContent>
  );
};

export default Cases;
